import React from 'react';
import classNames from 'classnames';
import { Search as USWDSSearch } from '@ver-uds/uswds-react';

export interface SearchProps {
  className?: string;
  id: string;
  placeholder?: string;
  onSubmit: (value: string) => void;
}

const Search = ({ className, id, placeholder, onSubmit }: SearchProps): JSX.Element => {
  return (
    <USWDSSearch
      id={id}
      className={classNames('ver-search', className)}
      onSubmit={onSubmit}
      size="small"
      placeholder={placeholder}
    />
  );
};

export default Search;
